import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import styles from './File.module.scss'

export const File = React.forwardRef(
  (
    {
      accept,
      error,
      fieldClassName,
      id,
      multiple,
      name,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isRequired = false,
    },
    ref,
  ) => (
    <input
      className={cx(styles.file, {
        [fieldClassName]: Boolean(fieldClassName),
        [styles.invalid]: Boolean(error),
      })}
      type="file"
      disabled={isDisabled}
      required={isRequired}
      {...{
        accept,
        id,
        multiple,
        name,
        ref,
        value,
        onBlur,
        onChange,
      }}
    />
  ),
)

export const ControlledFile = ({
  accept,
  control,
  error,
  fieldClassName,
  id,
  multiple,
  name,
  isDisabled,
  isRequired,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <File
        value={value?.fileName}
        onChange={event => onChange(event.target.files)}
        {...{
          accept,
          error,
          fieldClassName,
          id,
          multiple,
          name,
          ref,
          onBlur,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
